import script from "./side-nav-outer-toolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./side-nav-outer-toolbar.vue?vue&type=script&setup=true&lang=js"

import "./side-nav-outer-toolbar.vue?vue&type=style&index=0&id=413411ac&lang=scss"

const __exports__ = script;

export default __exports__